import { render, staticRenderFns } from "./AllocateLoansToDealModal.vue?vue&type=template&id=1bd50430"
import script from "./AllocateLoansToDealModal.ts?vue&type=script&lang=ts&external"
export * from "./AllocateLoansToDealModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd50430')) {
      api.createRecord('1bd50430', component.options)
    } else {
      api.reload('1bd50430', component.options)
    }
    module.hot.accept("./AllocateLoansToDealModal.vue?vue&type=template&id=1bd50430", function () {
      api.rerender('1bd50430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/AllocateLoansToDealModal.vue"
export default component.exports